import React, { useEffect, useRef, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import axios from "axios";
import exportToExcel from "../Report/ExportExcel";

const passengerTableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "20px",
};

const thTdStyle = {
  padding: "8px",
  border: "1px solid #ddd",
  textAlign: "left",
};

const thStyle = {
  backgroundColor: "#f2f2f2",
};

const CorporateTransactionss = ({ prRef }) => {
  const [data, setData] = useState([]);

  const getTransactions = async () => {
    const response = await axios
      .get("allCorporateTransactions/", {})
      .then((res) => {
        const transactionsWithMergedNames = res.data.map((transaction) => {
          const passengerName = `${transaction.passenger.firstName} ${transaction.passenger.lastName}`;
          const driverName = `${transaction.driver.firstName} ${transaction.driver.lastName}`;

          return {
            ...transaction,
            passenger: { ...transaction.passenger, name: passengerName },
            driver: { ...transaction.driver, name: driverName },
          };
        });

        setData(transactionsWithMergedNames);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getTransactions();
  }, []);
  const isCompanyUser = typeof window !== 'undefined' && localStorage.getItem('userType') === 'ambulance_company';
  const columns = [
    "Id",
    ...(!isCompanyUser ? ["Company", "Phone"] : []),
    ...(!isCompanyUser ? ["Passenger Name", "Passenger Phone"] : []),
    "Driver Name",
    "Driver Phone",
    "Price",
    "Revenue",
    "PickUp",
    "Destination",
    "Date",
  ];

  return (
    <div ref={prRef}>
      <Header
        title={"Corporate Transaction Information"}
        subTitle={""}
      />
      <table style={passengerTableStyle}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} style={{ ...thTdStyle, ...thStyle }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((trip, index) => (
            <tr key={index}>
              <td style={thTdStyle}>{trip.id}</td>
              {!isCompanyUser && (
                <>
                  <td style={thTdStyle}>{trip.company.companyName}</td>
                  <td style={thTdStyle}>{trip.company.phoneNumber}</td>
                </>
              )}

              {!isCompanyUser && (
                <>
                  <td style={thTdStyle}>{trip?.passenger?.name}</td>
                  <td style={thTdStyle}>{trip?.passenger?.phoneNumber}</td>
                </>
              )}

              <td style={thTdStyle}>{trip?.driver?.name}</td>
              <td style={thTdStyle}>{trip?.driver?.phoneNumber}</td>

              <td style={thTdStyle}>{trip?.trip.actualPrice}</td>
              <td style={thTdStyle}>{trip?.trip.revenue}</td>

              <td style={thTdStyle}>{trip?.trip.pickUpPlace}</td>
              <td style={thTdStyle}>{trip?.trip.destinationPlace}</td>

              <td style={thTdStyle}>
                {new Date(trip.trip.createdAt).toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Footer />
    </div>
  );
};

export const exportExcelCorporateTransactions = async () => {
  const getTransactions = async () => {
    const response = await axios
      .get("allCorporateTransactions/", {})
      .then((res) => {
        const isCompanyUser = typeof window !== 'undefined' && localStorage.getItem('userType') === 'ambulance_company';
        const transactionsWithMergedNames = res.data.map((transaction) => {
          const passengerName = `${transaction.passenger.firstName} ${transaction.passenger.lastName}`;
          const driverName = `${transaction.driver.firstName} ${transaction.driver.lastName}`;

          const base = {
            Id: transaction.id,
            "Driver Name": driverName,
            "Driver Phone": transaction.driver?.phoneNumber,
            Price: transaction.trip.actualPrice,
            Revenue: transaction.trip.revenue,
            PickUp: transaction.trip.pickUpPlace,
            Destination: transaction.trip.destinationPlace,
            Date: new Date(transaction.trip.createdAt).toLocaleString(),
          };

          if (!isCompanyUser) {
            base.Company = transaction.company.companyName;
            base.Phone = transaction.company.phoneNumber;
            base["Passenger Name"] = passengerName;
            base["Passenger Phone"] = transaction.passenger?.phoneNumber;
          }

          return base;
        });

        const headers = [
          "Id",
          ...(!isCompanyUser ? ["Company", "Phone", "Passenger Name", "Passenger Phone"] : []),
          "Driver Name",
          "Driver Phone",
          "Price",
          "Revenue",
          "PickUp",
          "Destination",
          "Date",
        ];

        exportToExcel(transactionsWithMergedNames, "corporateTransaction", headers);
      })
      .catch((err) => {});
  };

  getTransactions();
};

export default CorporateTransactionss;
